import React from 'react';
import { Tabs } from '@metarouter-private/mr-mui';
import { useTestPlaybookDrawerContext } from 'app/playbook-editor/transform-drawer/TestPlaybookDrawerContextProvider';
import buildAdvancedTabs from './buildAdvancedTabs';

// Advanced mode: end-to-end chain against the selected pipeline using the
// CURRENT (possibly unsaved) editor playbook — no saved revision required.
export default function AdvancedTabsSection() {
  const { chainState } = useTestPlaybookDrawerContext();

  return <Tabs value={chainState.selectedTab} onChange={chainState.onSelectTab} tabs={buildAdvancedTabs(chainState)} />;
}
